import { useLayoutEffect, useRef } from 'react';

/**
 * Grab an element by its DOM `id` attribute and return its `ref`.
 */
export const useGetElementById = <E extends HTMLElement = HTMLElement>(
  id: string,
) => {
  const elementRef = useRef<E | null>(null);

  useLayoutEffect(() => {
    elementRef.current = document.getElementById(id) as E;
  }, [id]);

  return elementRef;
};
